import ResponsiveImage, { type ResponsiveImageProps } from '../ResponsiveImage/ResponsiveImage';
import { DEFAULT_IMAGE_WIDTHS, imageSrc, imageSrcSet } from '@/lib/imageUrl';
import type { SanityImageData } from '@/types/sanity';

interface SanityImageProps
  extends Omit<ResponsiveImageProps, 'src' | 'srcSet' | 'sizes' | 'width' | 'height' | 'lqip'> {
  image: SanityImageData;
  /** How wide the image renders; see `ResponsiveImage/imageSizes.ts`. Required: a wrong value wastes bytes. */
  sizes: string;
  /** Candidate widths (px) to request from Sanity. */
  widths?: readonly number[];
}

/**
 * `ResponsiveImage` backed by Sanity's image pipeline: requests resized, WebP/AVIF
 * variants instead of the multi-MB original, and uses the intrinsic dimensions and
 * blurred LQIP that Sanity generates for every image.
 */
const SanityImage = ({ image, sizes, widths = DEFAULT_IMAGE_WIDTHS, ...props }: SanityImageProps) => (
  <ResponsiveImage
    {...props}
    src={imageSrc(image, widths[Math.floor(widths.length / 2)])}
    srcSet={imageSrcSet(image, widths)}
    sizes={sizes}
    width={image.dimensions?.width}
    height={image.dimensions?.height}
    lqip={image.lqip}
  />
);

export default SanityImage;
